/*
 * WHAT A CHAT TURN'S RUN ID LOOKS LIKE — defined once, because three layers depend on it.
 *
 * A top-level chat turn is not an agent run: it has no `agent_run` row and never will. But it CAN
 * spawn agents, and when it does it is their parent, so its id travels on `parent_run_id` exactly
 * where a real run's id would. Three places therefore have to agree on which of the two they are
 * holding:
 *
 *   • the chat turn that MINTS the id (base-ui `conversation.ts`)
 *   • the tool door, deciding whether stamping that parent NESTS a run or merely records its kin
 *   • `placement` / `listTree`, which must not look for an `agent_run` row that cannot exist
 *
 * Written in one place so the three cannot drift. A prefix rather than a separate field because the
 * id is already the thing that travels — adding a parallel "kind" would be a second fact to keep
 * true, and the failure mode of that disagreeing is a run grafted into a tree that never awaited it.
 */
export const TURN_RUN_PREFIX = 'turn-';

/** True when this id belongs to a chat turn rather than an agent run. */
export const isTurnRunId = (runId: string): boolean => runId.startsWith(TURN_RUN_PREFIX);
